import { AlertTriangle } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface ClearReviewQueueDialogProps {
  total: number;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  pending: boolean;
}

export function ClearReviewQueueDialog({
  total,
  open,
  onOpenChange,
  onConfirm,
  pending,
}: ClearReviewQueueDialogProps) {
  const eventsLabel = total === 1 ? "evento" : "eventi";

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Svuota coda revisione</DialogTitle>
          <DialogDescription>
            {total} {eventsLabel} in attesa di revisione manuale verranno
            segnati come &laquo;Ignorato&raquo;.
          </DialogDescription>
        </DialogHeader>

        <div className="flex gap-2.5 rounded-md border border-amber-300 bg-amber-50 p-3 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-950/30 dark:text-amber-200">
          <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0" />
          <p>
            Attenzione: l'azione riguarda <strong>tutti</strong> gli eventi in
            revisione, non solo quelli visualizzati. Nessun evento viene
            cancellato definitivamente: potrai ritrovarli nella pagina Eventi
            filtrando per stato &laquo;Ignorato&raquo; e, se necessario,
            riportarli a &laquo;Creato nel calendario&raquo; riaprendoli e
            cambiando lo stato.
          </p>
        </div>

        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={pending}
          >
            Annulla
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={pending}>
            {pending ? "Svuotamento..." : "Svuota coda"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
